export default "__VITE_IMAGE_ASSET__fb325658__";